import script from "./card.vue?vue&type=script&lang=ts&setup=true"
export * from "./card.vue?vue&type=script&lang=ts&setup=true"

import "./card.vue?vue&type=style&index=0&id=849730e2&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-849730e2"]])

export default __exports__